import { messaging } from "JS/Helpers/UserMessaging";
import { useRouting } from "JS/React/Hooks/Routes";
import { useSnackbar } from "JS/Helpers/Snackbar";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

export const AttachedSkuOffline = (props: AttachedSkuOfflineProps) => {
    useRedirectToOfflineHome();
    return null;
};

const useRedirectToOfflineHome = () => {
    const navigate = useNavigate();
    const { linkProvider } = useRouting();
    const { enqueueSnackbar } = useSnackbar();

    const redirectToHomeWithMessage = () => {
        enqueueSnackbar(messaging.attachSku.offline, {
            variant: "warning",
        });
        navigate(linkProvider.react.offline().index(), { replace: true });
    };

    useEffect(() => {
        redirectToHomeWithMessage();
    }, []);
};

export interface AttachedSkuOfflineProps {}
